<script lang="ts">
  import Button from "$lib/Button.svelte";
</script>

<p class="m-0 grid grid-cols-2 gap-2">
  <Button
    class="text-start text-base"
    href="https://apps.apple.com/no/app/ishavskraft/id1528706031"
  >
    {#snippet iconStart()}
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="100"
        height="100"
        viewBox="0 0 64 64"
      >
        <path
          d="M54.166,19.783c-0.258,0.162-6.401,3.571-6.401,11.13c0.29,8.621,7.752,11.644,7.88,11.644	c-0.128,0.162-1.127,4.119-4.085,8.267C49.213,54.398,46.607,58,42.65,58c-3.764,0-5.115-2.381-9.458-2.381	c-4.664,0-5.984,2.381-9.555,2.381c-3.957,0-6.756-3.795-9.232-7.335c-3.216-4.633-5.95-11.903-6.047-18.883	c-0.065-3.699,0.644-7.335,2.444-10.423c2.541-4.312,7.077-7.238,12.031-7.335c3.795-0.128,7.173,2.606,9.49,2.606	c2.22,0,6.37-2.606,11.065-2.606C45.415,14.026,50.82,14.636,54.166,19.783z M32.002,13.285c-0.676-3.378,1.19-6.756,2.927-8.911	C37.149,1.769,40.655,0,43.678,0c0.193,3.378-1.03,6.691-3.216,9.104C38.5,11.71,35.122,13.671,32.002,13.285z"
        ></path>
      </svg>
    {/snippet}
    <small class="block">Last ned fra</small>
    <span class="text-sm laptop:text-body">App Store</span>
  </Button>

  <Button
    class="text-start text-base"
    href="https://play.google.com/store/apps/details?id=no.Ishavskraft.Ishavskraft&pli=1&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
  >
    {#snippet iconStart()}
      <svg aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <path fill="none" d="M0,0h40v40H0V0z"></path><g
          ><path
            d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
            fill="#EA4335"
          ></path><path
            d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
            fill="#FBBC04"
          ></path><path
            d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z"
            fill="#4285F4"
          ></path><path
            d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
            fill="#34A853"
          ></path></g
        >
      </svg>
    {/snippet}
    <small class="block">Last ned fra</small>
    <span class="text-sm laptop:text-body">Google Play</span>
  </Button>
</p>

<style lang="postcss">
  svg {
    width: 2em;
  }

  @media (--tablet) {
    svg {
      width: 2.5em;
    }
  }
</style>
